// IMPORT PACKAGE REFERENCES
import React, { Component } from 'react';

// IMPORT PROJECT REFERENCES
import { CurrentAnalysisStatsBrowser } from './CurrentAnalysisStatsBrowser';

// COMPONENT
class CurrentAnalysisStatsWidget extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="card bg-light mb-3">
                <div className="card-body">
                    <div className="card-title">
                        <div className="d-flex justify-content-between">
                            <h6>Analysis Stats</h6>
                        </div>
                    </div>
                    <CurrentAnalysisStatsBrowser />
                </div>
            </div>
        );
    }
}

export { CurrentAnalysisStatsWidget };
